import * as customerPortalApi from '@kk/api/modules/customer-portal.deprecated';
import * as leasingApi from '@kk/api/modules/leasing';
import * as loanApi from '@kk/api/modules/loan';
import { ClientConfig } from '@/client-config';
import { fetchWithCredentials, headers } from './options';

customerPortalApi.defaults.baseUrl = ClientConfig.apiUrl;
loanApi.defaults.baseUrl = `${ClientConfig.apiUrl}/loan/v1`;
leasingApi.defaults.baseUrl = ClientConfig.leasingApiUrl;
leasingApi.defaults.credentials = 'include';
leasingApi.defaults.fetch = fetchWithCredentials;
leasingApi.defaults.headers = headers;

export { customerPortalApi, leasingApi, loanApi };
